import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import types from './types';

const URL = `${BASE_API}/products-by-owner/station`;
const URL_DETAIL = `${BASE_API}/product-details`;

export const getList = (id, page = 1, limit = 5, search = '') => {
  return (dispatch) => {
    dispatch({ type: types.PRODUCT_BY_OWNER_LOAD, payload: true });
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        params: {
          page,
          limit,
          search,
        },
      })
      .then((response) => {
        const data = Array.isArray(response.data?.data) ? response.data.data : [];
        const pagination = response.data?.pagination || {
          page: 1,
          limit: 5,
          total: 0,
          totalPages: 1,
        };

        data.forEach((item) => {
          item.validated = parseInt(item.validated) === 0 ? 'Não' : 'Sim';
        });
        dispatch([
          {
            type: types.PRODUCT_BY_OWNER_FETCHED,
            payload: { data, pagination },
          },
        ]);
      })
      .catch((error) => {
        console.error('Erro ao buscar produtos:', error);
        dispatch([
          {
            type: types.PRODUCT_BY_OWNER_FETCHED,
            payload: {
              data: [],
              pagination: { page: 1, limit: 5, total: 0, totalPages: 1 },
            },
          },
        ]);
      });
  };
};

export const setPage = (page) => {
  return {
    type: types.PRODUCT_BY_OWNER_SET_PAGE,
    payload: page,
  };
};

// Função que retorna Promise para buscar detalhes do produto (usada para exportação)
export const fetchProductDetails = async (id) => {
  const response = await axios.get(`${URL_DETAIL}/${id}`, {
    headers: {
      Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
    },
  });
  return response.data;
};

export const getDetail = (id) => {
  return (dispatch) => {
    dispatch({ type: types.PRODUCT_BY_OWNER_DETAIL_LOAD, payload: true });
    axios
      .get(`${URL_DETAIL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.PRODUCT_BY_OWNER_DETAIL_FETCHED,
            payload: response,
          },
        ]);
      });
  };
};
